import { CacheKeys } from 'cache-keys-enum';
import { ApiRoute, SortOrder } from 'enums';

import { useQuery } from 'react-query';
import { ArchivalCollection, Result } from 'types';
import fetch from 'utils/fetch';

export const useArchivalCollectionDetail = (collectionId?: string) =>
  useQuery(
    [CacheKeys.ARCHIVAL_COLLECTION, collectionId],
    () =>
      fetch(`/api/${ApiRoute.ARCHIVAL_COLLECTION}/${collectionId}`).then(
        async (r) => (await r.json()) as ArchivalCollection
      ),
    { enabled: !!collectionId }
  );

export const useArchivalCollections = (originatorId?: string) => {
  const response = useQuery(
    [CacheKeys.COLLECTION_LIST_BY_ORIGINATOR, originatorId],
    () =>
      fetch(`/api/${ApiRoute.ARCHIVAL_COLLECTION}/list`, {
        method: 'POST',
        body: JSON.stringify({
          sort: [{ field: 'name', order: 'ASC' as SortOrder }],
          size: -1,
          filters: originatorId
            ? [
                {
                  operation: 'OR',
                  filters: [
                    {
                      operation: 'EQ',
                      field: 'originators.id',
                      value: originatorId,
                    },
                    {
                      operation: 'EQ',
                      field: 'placesOfOrigin.id',
                      value: originatorId,
                    },
                  ],
                },
              ]
            : [],
        }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      }).then(async (r) => (await r.json()) as Result<ArchivalCollection>)
  );

  return response;
};
